"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _autoGenCrumb = _interopRequireDefault(require("./auto-gen-crumb"));

var _jsxFileName = "/home/circleci/project/src/components/sitemap-crumbs.js";

// TODO: Delete before v7 release
var SitemapCrumbs = function SitemapCrumbs(props) {
  // eslint-disable-next-line
  console.warn("Warning: <SitemapCrumbs /> has been deprecated.  Please update your code to use <Breadcrumb /> component. See docs https://github.com/sbardian/gatsby-plugin-breadcrumb for details.");
  return _react.default.createElement(_autoGenCrumb.default, (0, _extends2.default)({}, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: this
  }));
};

var _default = SitemapCrumbs;
exports.default = _default;